export default __webpack_public_path__ + "static/media/Software-Quality-Assurance-Illustration.edd76d8a.svg";